import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";

import { AttributeAnswer } from "../Swiper/Swiper";
import { Background } from "./Background";
import { GameHandler, GameHandlerProps } from "../../types";
import { integrationApi } from "../../main";
import { NicknameModal } from "../shared/NicknameModal";
import { RESPONSE_CREATE } from "../../graphql/mutations/Response";
import { ResponseKind, SwiperConfiguration } from "../../gql/graphql";
import { Swiper } from "../Swiper";
import { useGlobalConfiguration } from "../../hooks/useGlobalConfiugration";
import { isSwiperGame } from "../../graphql/helpers/isSwiperGame";

export const SwiperGame: GameHandler = ({ game, finishGame }: GameHandlerProps) => {
  const { projectNickname } = useGlobalConfiguration();
  const { showLeaderboard, leaderboardConfiguration } = game.configuration as SwiperConfiguration;
  const [nickname, setNickname] = useState<string | undefined>(projectNickname || undefined);
  const [startTime, setStartTime] = useState(new Date());
  const [responseCreate] = useMutation(RESPONSE_CREATE);
  const { isPreviewMode } = useGlobalConfiguration();
  const isLeaderboardVisible = showLeaderboard && !nickname;

  useEffect(() => {
    if (projectNickname) {
      setNickname(projectNickname);
    }
  }, [projectNickname]);

  useEffect(() => {
    if (nickname) {
      setStartTime(new Date());
    }
  }, [nickname]);

  const saveResponse = async (answers: AttributeAnswer[]) => {
    if (isPreviewMode) {
      return finishGame();
    }

    const responseKind =
      integrationApi.configuration.provider === "alchemer" ? ResponseKind.Alchemer : ResponseKind.Hosted;

    const { data } = await responseCreate({
      variables: {
        data: {
          responseKind,
          startTime: startTime.toISOString(),
          endTime: new Date().toISOString(),
          nickname: nickname,
          gameId: game.id,
          attributeScores: answers.map((answer) => ({
            attributeId: answer.attributeId,
            score: answer.result ? 1 : 0,
          })),
        },
      },
    });

    finishGame(String(data?.responseCreate.slug));
  };

  return (
    <Background gameVisuals={game.configuration.gameVisuals}>
      <NicknameModal
        isOpen={isLeaderboardVisible}
        gameId={game.id}
        themeColor={game.configuration.gameVisuals.themeColor}
        onContinue={setNickname}
        configuration={leaderboardConfiguration}
      />
      {isSwiperGame(game) && (
        <Swiper onFinish={saveResponse} configuration={game.configuration as SwiperConfiguration} />
      )}
    </Background>
  );
};
